import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, Handshake } from "lucide-react";
import { Section, Overline } from "@/components/Primitives";

const EASE = [0.22, 0.61, 0.36, 1];

const PARTNERS = [
  {
    name: "Qantas",
    logo: "/partners/qantas.png",
    text: "Compagnie aérienne recommandée pour certains voyages vers l'Australie.",
    url: "https://www.qantas.com",
  },
  {
    name: "Chapka Assurances",
    logo: "/partners/chapka.png",
    text: "Solutions d'assurance voyage adaptées aux projets internationaux.",
    url: "https://www.chapkadirect.fr",
  },
];

export const PartnersSection = () => (
  <section data-testid="partners-section" className="bg-[#F8F9FA]">
    <Section className="py-20">
      <div className="text-center">
        <Overline>Nos solutions recommandées</Overline>
        <h2 data-testid="partners-title" className="mt-4 font-heading text-3xl font-medium text-navy sm:text-4xl">
          Partenaires et services recommandés
        </h2>
        <div className="gold-line mx-auto mt-6" />
      </div>

      <div className="mx-auto mt-12 grid max-w-4xl gap-6 sm:grid-cols-2">
        {PARTNERS.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-testid={`partner-card-${p.name.toLowerCase().split(" ")[0]}`}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: EASE }}
            className="group flex flex-col items-center rounded-2xl border border-border bg-white px-8 py-10 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-gold hover:shadow-xl"
          >
            {/* Logo officiel */}
            <div className="flex h-20 w-full items-center justify-center">
              <img
                src={p.logo}
                alt={`Logo ${p.name}`}
                loading="lazy"
                className="h-auto w-full max-w-[240px] object-contain transition-transform duration-300 group-hover:scale-[1.04]"
              />
            </div>

            <div className="mt-2 h-px w-14 bg-gold/60" />

            <p className="mt-5 text-sm leading-relaxed text-slate-700">
              <span className="font-medium text-navy">{p.name}</span> — {p.text}
            </p>

            <span className="mt-6 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-navy/60 transition-colors group-hover:text-gold">
              Visiter le site <ExternalLink size={13} />
            </span>
          </motion.a>
        ))}
      </div>

      <p className="mt-8 flex items-center justify-center gap-2 text-center text-xs text-muted-foreground">
        <Handshake size={14} className="text-gold" />
        Recommandations à titre informatif — chaque prestataire reste indépendant.
      </p>
    </Section>
  </section>
);
